import type { Batch } from './Batch';

export interface BatchActions {
  canEdit: boolean;
  canBlock: boolean;
  canUnblock: boolean;
  canDelete: boolean;
}

export const getBatchActions = (batch: Batch): BatchActions => {
  const isDeleted = !!batch.deleted_at;
  const isBlocked = !!batch.blocked_at && !batch.unblocked_at;

  if (isDeleted) {
    return { canEdit: false, canBlock: false, canUnblock: false, canDelete: false };
  }

  if (isBlocked) {
    return {
      canEdit: batch.allow_entries_when_blocked,
      canBlock: false,
      canUnblock: true,
      canDelete: false,
    };
  }

  return { canEdit: true, canBlock: true, canUnblock: false, canDelete: true };
};
